import React from "react";
import PropTypes from "prop-types";
import { useInView } from "react-intersection-observer";

// components
import FourCards from "../../Cards/FourCards";

// styles
import * as styles from "./InsurancePartner.module.css";

// images
import metabolicIcon from "../../../images/forInsurer/metabolic-icn.png";
import hospitalIcon from "../../../images/forInsurer/hospital-icn.png";
import modelIcon from "../../../images/forInsurer/model-icn.png";
import twinIcon from "../../../images/forInsurer/twin-icn.png";

const propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

const defaultProps = {
  title: "Why Insurance Partners Choose Metabolic Care Programmes",
  description:
    "Our insurance partners use Twin Health’s proactive care model to help policyholders stay healthier, reduce hospitalizations, and lower long-term claim costs.",
};

const InsurancePartner = ({ title, description }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const cardsData = [
    {
      icon: metabolicIcon,
      title: "Metabolic diseases are surging.",
      description:
        "Diabetes, BP, and fatty liver drive most health claims in India.",
      iconAlt: "Metabolic diseases icon",
    },
    {
      icon: hospitalIcon,
      title: "Hospital costs outpace premiums.",
      description: "Lifestyle-related NCDs keep pushing claim amounts higher.",
      iconAlt: "Hospital costs icon",
    },
    {
      icon: modelIcon,
      title: "Old models only reimburse.",
      description: "Traditional insurance reacts to illness, not prevention.",
      iconAlt: "Insurance model icon",
    },
    {
      icon: twinIcon,
      title: "Twin Health in India steps in.",
      description:
        "We help insurers shift to proactive care and attain lowers claims.",
      iconAlt: "Twin Health icon",
    },
  ];

  return (
    <section className={styles.insurancePartnerWrapper}>
      <div
        ref={ref}
        className={`container scroll_animate ${inView && "inview"}`}
      >
        {/* Header Section */}
        <div className={styles.headerSection}>
          <h2 className={styles.title}>{title}</h2>
        </div>

        {/* Cards Section */}
        <div className={styles.cardsSection}>
          <FourCards cards={cardsData} variant="default" />
        </div>

        {/* Description Section */}
        <div className={styles.descriptionSection}>
          <p className={styles.description}>{description}</p>
        </div>
      </div>
    </section>
  );
};

InsurancePartner.propTypes = propTypes;
InsurancePartner.defaultProps = defaultProps;

export default InsurancePartner;
